import { Loader } from '@/components/ui'

const SUPPORT_EMAIL = 'support@counselpro.ai'

interface FinishingSetupProps {
  isSlow: boolean
}

export const FinishingSetup = ({ isSlow }: FinishingSetupProps) => (
  <div role="status" className="flex flex-col gap-2">
    <Loader size="md" className="text-brand-deep" />
    <h1 className="text-2xl font-semibold tracking-tight">Finishing setup</h1>
    {isSlow ? (
      <p className="text-[15px] text-muted-foreground">
        Taking longer than usual. Refresh in a moment, or{' '}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="font-medium text-brand-deep hover:underline"
        >
          email us
        </a>
        .
      </p>
    ) : (
      <p className="text-[15px] text-muted-foreground">
        We are starting your trial. This takes a few seconds.
      </p>
    )}
  </div>
)
